import DELETE_ECG_BOOKMARKS from '@/entities/bookmark/api/mutations/deleteEcgBookmarks';
import { createClient } from '@/shared/api';
import type {
  DeleteEcgBookmarksMutation,
  DeleteEcgBookmarksMutationVariables,
} from '@/shared/api/generated/graphql';

export type DeleteEcgBookmarksResult = {
  isSuccess: boolean;
  message: string;
};

/**
 * Removes ECG bookmarks by id. Runs the deleteEcgBookmarks mutation and throws the server message when it reports failure.
 *
 * @param ids - Ids of the bookmarks to delete; defaults to an empty list.
 * @returns A promise resolving once the bookmarks have been deleted.
 */
const handleDeleteEcgBookmarks = async (ids: string[] = []) => {
  const client = await createClient();
  const result = await client.mutate<
    DeleteEcgBookmarksMutation,
    DeleteEcgBookmarksMutationVariables
  >({
    mutation: DELETE_ECG_BOOKMARKS,
    variables: {
      ids,
    },
  });
  const { data } = result;
  const { deleteEcgBookmarks } = data;
  if (!deleteEcgBookmarks.isSuccess) {
    throw new Error(deleteEcgBookmarks.message);
  }
};

export default handleDeleteEcgBookmarks;
